import React, { useContext } from "react";
import { motion } from "framer-motion";
import { useNavigate, useSearchParams } from "react-router-dom";
import "./order-success.css";
import { GlobalContext } from "../../GlobalContext";

const OrderSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const reference = searchParams.get("reference");
  const { userData } = useContext(GlobalContext);

  const formVariants = {
    hidden: { opacity: 0, scale: 0.95 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: { duration: 0.6, ease: "easeOut", staggerChildren: 0.2 },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.4, ease: [0.6, -0.05, 0.01, 0.99] },
    },
  };

  const buttonVariants = {
    hover: {
      scale: 1.02,
      backgroundColor: "#d1d9e6",
      transition: { duration: 0.2 },
    },
    tap: { scale: 0.98 },
  };

  const handleFillRequisition = () => {
    if (reference) {
      // Navigate to requisition form with order_id
      navigate(`/order-test?order_id=${reference}`);
    } else {
      navigate("/my-orders"); // Fallback to My Orders if reference is missing
    }
  };

  return (
    <div className="order-success-container">
      <motion.div
        className="order-success-content"
        variants={formVariants}
        initial="hidden"
        animate="visible"
      >
        <motion.div className="order-success-card" variants={itemVariants}>
          <img
            src={`${process.env.PUBLIC_URL}/assets/logo.svg`}
            alt="Direct by Syndicate Bio"
            className="order-success-logo"
          />
          <div className="order-success-message-hero">
            <img
              src={`${process.env.PUBLIC_URL}/assets/testtube.png`}
              alt="Test Tube"
              className="order-success-image"
            />
            <motion.div className="order-success-message" variants={itemVariants}>
              <h2 className="order-success-title">Order Placed!</h2>
              <p className="order-success-text">
                Your test order has been successfully placed. You will receive updates as the process progresses.
              </p>
            </motion.div>
            <motion.button
              onClick={handleFillRequisition}
              className="view-order-button"
              variants={buttonVariants}
              whileHover="hover"
              whileTap="tap"
            >
              Fill requisition form
            </motion.button>
          </div>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default OrderSuccess;